const getters = {
    editableTabs: state => state.app.editableTabs,
    selectTabName: state => state.app.selectTabName,
    currentWidth: state => state.app.currentWidth,
    isSideShow: state => state.app.isSideShow,
    isHeadShow: state => state.app.isHeadShow,
    token: state => state.user.token,
    refreshToken: state => state.user.refreshToken,
    name: state => state.user.name,
    menu: state => state.user.menu,
    toolbar: state => state.user.toolbar,
    avatar: state => state.user.avatar
};

export default getters;
